import { render, staticRenderFns } from "./SampleHeader.vue?vue&type=template&id=3db893f4"
import script from "./SampleHeader.vue?vue&type=script&lang=js"
export * from "./SampleHeader.vue?vue&type=script&lang=js"
import style0 from "./SampleHeader.vue?vue&type=style&index=0&id=3db893f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports